var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4L5 7L12 10L19 7L12 4Z",
    stroke: "#222222",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1973 11.5396C19.3809 11.6183 19.4998 11.7997 19.5 11.9995C19.5 12.1994 19.381 12.3806 19.1973 12.4595L12.1973 15.4595C12.0715 15.5134 11.9285 15.5134 11.8027 15.4595L4.80273 12.4595C4.61905 12.3806 4.5 12.1994 4.5 11.9995C4.50017 11.7997 4.61909 11.6183 4.80273 11.5396L7.65918 10.3159L8.92969 10.8589L6.27051 11.9995L12 14.4546L17.7295 11.9995L15.0693 10.8589L16.3398 10.3159L19.1973 11.5396Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1973 16.5396C19.3809 16.6183 19.4998 16.7997 19.5 16.9995C19.5 17.1994 19.381 17.3806 19.1973 17.4595L12.1973 20.4595C12.0715 20.5134 11.9285 20.5134 11.8027 20.4595L4.80273 17.4595C4.61905 17.3806 4.5 17.1994 4.5 16.9995C4.50017 16.7997 4.61909 16.6183 4.80273 16.5396L7.65918 15.3159L8.92969 15.8589L6.27051 16.9995L12 19.4546L17.7295 16.9995L15.0693 15.8589L16.3398 15.3159L19.1973 16.5396Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectsIcon);
export default __webpack_public_path__ + "static/media/projects-icon.0a6c55c2640f09e7076ebcc07f08b85f.svg";
export { ForwardRef as ReactComponent };